import * as React from 'react'
import MaterialSnackbar from 'material-ui/Snackbar'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import { Base_Component } from '../Base/Base.ui.Component'
import { DS_setData } from '../DS/DS.Data'
import { DS_Listen } from '../DS/DS.ui.Listen'
import { Plat_vibrate } from '../Plat/Plat.device'

export function UI_snackbarMessage(message: string) {
    Plat_vibrate(50)
    DS_setData('SnackbarMessage', ({ snackbarMessages }) => ({
        snackbarMessages: snackbarMessages.concat(message),
    }))
}

async function snackbarMessageSwitch() {
    // Start the switch
    DS_setData('SnackbarMessageSwitchStart', () => ({ snackbarIsSwitching: true }))

    // Wait for a bit to let it be visible to user
    await timeout(500)

    // Actually do the switch
    DS_setData('SnackbarMessageSwitchEnd', ({ snackbarMessages }) => ({
        snackbarMessages: snackbarMessages.slice(1, snackbarMessages.length),
        snackbarIsSwitching: false,
    }))
}

export class UI_Snackbar extends Base_Component<{}, {}> {
    public tryRender() {
        return DS_Listen(
            (d) => ({ messages: d.snackbarMessages, isSwitching: d.snackbarIsSwitching }),
            ({ messages, isSwitching }) => (
                <MaterialSnackbar
                    open={messages.length > 0 && !isSwitching}
                    message={messages[0] || ''}
                    autoHideDuration={2000}
                    onRequestClose={snackbarMessageSwitch}
                />
            )
        )
    }
}
